import unfavoriteQuery from './unfavorite-query.action';

export default unfavoriteQuery;
